import React, { Component } from 'react'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Column from '~/Common-Objects/Grids/Column/Column'
import DataTable1 from '~/Common-Objects/Tables/DataTable1/DataTable1'
import Icons from '~/Common-Objects/UI/Icons/index'
import LoadingIcons from '~/Common-Objects/LoadingIcons/loadingIcon1'
import Paper from '~/Common-Objects/UI/Paper/Paper'
import Row from '~/Common-Objects/Grids/Row/Row'
import SquareChip from '~/Common-Objects/UI/Chips/SquareChip.jsx'
import axios from '~/data/http/axios'
import DateTimeFunctions from '~/Classes/dateTimeFunctions'
import NumberFunctions from '~/Classes/numberFormatFunctions'
import { connect } from 'react-redux'
import * as siteMaster from '~/data/actions/siteActions' //now we can use user actions here
import PermissionChecker from '~/Classes/permissions'
import i18n from '~/i18n'

import AddEvent from './addEvent'
import DeleteEvent from './deleteEvent'

@connect((store) => {
    return { site: store.siteMaster, accountMaster: store.accountMaster, permissionStore: store.permission }
})
class SiteTrackingEvents extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: true,
            events: [],
            tableData: [],
            writeAccess: PermissionChecker('company', this.props.permissionStore.permissions, 'write')
        }
        this.getEvents = this.getEvents.bind(this)
        this.addEvent = this.addEvent.bind(this)
        this.addedEvent = this.addedEvent.bind(this)
        this.deleteEvent = this.deleteEvent.bind(this)
    }

    componentDidMount() {
        this.getEvents()
    }

    async getEvents() {
        let events = await axios.get(`/accountMaster/tracker/events`)
        events = events.data
        let tableData = events.map((row) => {
            return [
                {
                    headerValue: 'Id',
                    value: row.id,
                    width: 40
                },
                {
                    headerValue: 'Event',
                    value: <strong>{row.name}</strong>
                },
                {
                    headerValue: 'Hits',
                    value: row.hits
                },
                {
                    headerValue: 'Value',
                    value: row.value
                        ? this.props.accountMaster.accountMaster.currencySymbol +
                          NumberFunctions.formatNumber(row.value, 2)
                        : ''
                },
                {
                    headerValue: 'Values Available',
                    value: row.detectedValues
                        ? row.detectedValues.map((m) => {
                              return <SquareChip className='mar-r5 mar-b5'>{m.name}</SquareChip>
                          })
                        : ''
                },
                {
                    headerValue: '',
                    value: row.system ? (
                        <>
                            <SquareChip>System</SquareChip>
                        </>
                    ) : (
                        this.state.writeAccess && (
                            <Icons
                                icon='bin'
                                color='#FF0000'
                                onClick={() => {
                                    this.deleteEvent(row)
                                }}
                            />
                        )
                    ),
                    width: 50,
                    align: 'center'
                }
            ]
        })
        this.setState({ tableData, loading: false, events: events })
    }

    addEvent() {
        var drawerContent = <AddEvent tracker={this.props.tracker} close={this.addedEvent} />
        this.props.dispatch(siteMaster.alterSiteDrawer(true, true, 'right', drawerContent, true, '500px'))
    }

    addedEvent() {
        this.props.dispatch(siteMaster.alterSiteDrawer(false, false, 'right', null, true))
        this.getEvents()
    }

    deleteEvent(event) {
        var drawerContent = <DeleteEvent tracker={this.props.tracker} event={event} close={this.addedEvent} />
        this.props.dispatch(siteMaster.alterSiteDrawer(true, true, 'right', drawerContent, true, '500px'))
    }

    render() {
        if (this.state.loading) return <LoadingIcons iconType='2' />
        return (
            <>
                <Row>
                    <Column xs={12} sm={6} md={8}>
                        <Paper>
                            <div className='quickFlex mar-b25' style={{ justifyContent: 'space-between' }}>
                                <h4>Your Events</h4>
                                <Button
                                    iconLeft={<Icons icon='plus' />}
                                    text='Add an Event'
                                    tooltip={!this.state.writeAccess ? "You don't have permission to do this" : ''}
                                    for={'addEventBtn'}
                                    disabled={!this.state.writeAccess}
                                    onClick={this.addEvent}
                                />
                            </div>
                            <DataTable1
                                noResultsTxt={i18n.t('campaigns:sitetracking.trackingvistors.noDataFound')}
                                tableData={this.state.tableData}
                                dataUpdater={() => {}}
                                width='100%'
                                pageSize='100'
                                hasCheckBoxes='no'
                                sortedColumn={''}
                                sortedDirection={''}
                                loadingData={this.state.loading}
                            />
                        </Paper>
                    </Column>
                    <Column xs={12} sm={6} md={4}>
                        <Paper>
                            <h4 className='mar-b25'>What are Events?</h4>
                            <div className='mar-b10'>
                                Site Tracking events enable you to track the things your customers do around your
                                website or service.
                            </div>
                            <div className='mar-b10'>
                                You will then be able to attribute success to your marketing efforts, by seeing the
                                number of registrations, payments and more that your customers have completed because of
                                campaigns
                            </div>
                            <div className='mar-b10'>There are two built in events...</div>
                            <Paper className='mar-b15' style={{ padding: '15px' }}>
                                <div className='text-heavy'>Registrations</div>
                                <div>Send this event when a customer registers or signs up, etc.</div>
                            </Paper>
                            <Paper className='mar-b15' style={{ padding: '15px' }}>
                                <div className='text-heavy'>Payments</div>
                                <div>
                                    Send this event whenever a payment is made. You can also supply a{' '}
                                    <strong>value</strong> with this event so you can track the success of your
                                    marketing
                                </div>
                            </Paper>
                            {this.state.writeAccess && (
                                <div>
                                    You can also <a onClick={this.addEvent}>add your own</a> custom events.
                                </div>
                            )}
                        </Paper>

                        <Paper>
                            <h4 className='mar-b25'>How to use Events</h4>

                            <div className='mar-b10'>
                                There are two ways you can send events in when customers do things on your site or
                                service.
                            </div>
                            <Paper>
                                <div className='quickFlex mar-b10' style={{ justifyContent: 'space-between' }}>
                                    <div className='text-heavy'>When they reach a page</div>
                                    <SquareChip className='square-chip-green'>Easy</SquareChip>
                                </div>
                                <div className='mar-b10'>
                                    Automatically trigger an event when a customer visits a specific page.
                                </div>
                                <div className='text-heavy'>
                                    To get started, click into one of your sites, then the Pages tab, then click the Add
                                    Event button next to a page.
                                </div>
                            </Paper>

                            <Paper>
                                <div className='quickFlex mar-b10' style={{ justifyContent: 'space-between' }}>
                                    <div className='text-heavy'>Programatically</div>
                                    <SquareChip className='square-chip-orange'>Advanced</SquareChip>
                                </div>
                                <div className='mar-b10'>
                                    Use the API or extend the Site Tracking Javascript to push events and custom events.
                                </div>
                                <Button
                                    text='Get Started'
                                    iconRight={<Icons icon='arrowRight' />}
                                    onClick={() => {
                                        this.props.history.push('/cp/trackers/advanced')
                                    }}
                                />
                            </Paper>
                        </Paper>
                    </Column>
                </Row>
            </>
        )
    }
}
export default SiteTrackingEvents
